import React, { useState, useEffect, useRef } from "react"
import { Field } from "formik"

const TextArea = ({ name, label, ...props }) => (
	<Field name={name} as={GrowingTextAreaComponent} placeholder={label} {...props} />
)

const GrowingTextAreaComponent = ({ name, placeholder, className, ...props }) => {
	const textAreaRef = useRef(null)
	const [text, setText] = useState("")
	const [textAreaHeight, setTextAreaHeight] = useState("auto")
	const [parentHeight, setParentHeight] = useState("auto")

	useEffect(() => {
		setParentHeight(`${textAreaRef.current.scrollHeight}px`)
		setTextAreaHeight(`${textAreaRef.current.scrollHeight}px`)
	}, [text])

	const onChangeHandler = event => {
		setTextAreaHeight("auto")
		setParentHeight(`${textAreaRef.current.scrollHeight}px`)
		setText(event.target.value)

		if (props.onChange) {
			props.onChange(event)
		}
	}

	return (
		<div className={`w-full ${className || ""}`}>
			<div
				style={{
					minHeight: parentHeight,
				}}
				className="flex w-full flex-col justify-center rounded-medium
				bg-white px-20 pt-16 pb-[12px] border border-iron focus-within:border-pictonblue hover:border-jetblack hover:focus-within:border-pictonblue">
				<div className="relative">
					<textarea
						{...props}
						id={name}
						name={name}
						placeholder={placeholder}
						ref={textAreaRef}
						rows={3}
						style={{
							height: textAreaHeight,
						}}
						className="z-1 peer m-0 mt-[19px] w-full appearance-none border-none bg-transparent p-0 text-base placeholder-transparent outline-none transition-all placeholder-shown:mt-0 focus:mt-[19px] focus:ring-0 focus:ring-offset-0 h-fit resize-none"
						onChange={onChangeHandler}
					/>
					<label
						htmlFor={name}
						className="transition-all z-1 absolute left-0 m-0 p-0 text-nevada opacity-90 peer-focus:opacity-90 peer-placeholder-shown:opacity-50 text-xs peer-placeholder-shown:text-base peer-focus:text-xs">
						{placeholder}
						{!props.required && (
							<span className="text-xs italic">&nbsp;(optional)</span>
						)}
					</label>
				</div>
			</div>
		</div>
	)
}

export default TextArea
